(function () {
  const addClasses = (slider) => {
    const sliderWrapper = slider.querySelector(".multicolumn-list__wrapper");
    const slides = slider.querySelectorAll(".multicolumn-list__item");

    slider.classList.add("swiper");
    if (sliderWrapper) sliderWrapper.classList.add("swiper-wrapper");
    if (slides.length > 1) {
      slides.forEach((slide) => {
        slide.classList.add("swiper-slide");
      });
    }
  };

  const initSlider = (section) => {
    // GUARD ORDER IS THE FIX.
    //
    // `slider.dataset` used to be read on the line ABOVE the `if (slider)`
    // check, so a section with no `.swiper--multicolumn` element threw
    // "Cannot read properties of null (reading 'dataset')" before the guard was
    // ever reached — and that killed the rest of this script.
    //
    // It is not an edge case here: that element only exists when the section's
    // `swiper` setting is on AND it has more than one block
    // (sections/multicolumn.liquid:19). The homepage "why us" row has swiper
    // off, so this threw on every homepage load.
    //
    // Returning early preserves the original behaviour exactly — everything
    // below already only ran when `slider` existed.
    if (!section) return;

    const slider = section.querySelector(".swiper--multicolumn");
    if (!slider) return;

    // Radix pinned, and a sane fallback: parseInt("") is NaN, and NaN in the
    // breakpoint comparisons below silently produced `slidesPerView: NaN`.
    const columnsPerRow = parseInt(slider.dataset.columns_per_row, 10) || 1;

    addClasses(slider);

    var multicolumnSwiper = new Swiper(slider, {
      loop: false,
      speed: 800,
      spaceBetween: 0,
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
        },
        750: {
          slidesPerView: columnsPerRow > 1 ? 2 : columnsPerRow,
          slidesPerGroup: 2,
          spaceBetween: 24,
        },
        1100: {
          slidesPerView: columnsPerRow > 2 ? 3 : columnsPerRow,
          spaceBetween: 24,
        },
        1360: {
          slidesPerView: columnsPerRow > 3 ? 4 : columnsPerRow,
          spaceBetween: 24,
        },
        1600: {
          slidesPerView: columnsPerRow,
          spaceBetween: 24,
        },
      },
      pagination: {
        el: slider.querySelector(".multicolumn__pagination"),
        clickable: true,
        type: "custom",
        renderCustom: function (swiper, current, total) {
          let out = "";
          for (let i = 1; i < total + 1; i++) {
            if (i == current) {
              out = `${out}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
            } else {
              out = `${out}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
            }
          }
          return out;
        },
      },
      navigation: {
        // Element refs rather than the old `#${id} .swiper-button-next`, which
        // was built with jQuery. The buttons live inside this section anyway,
        // so this is equivalent, drops a jQuery dependency, and a section with
        // no id can no longer produce the invalid selector "#".
        nextEl: section.querySelector(".swiper-button-next"),
        prevEl: section.querySelector(".swiper-button-prev"),
      },
    });

    setTimeout(() => {
      multicolumnSwiper.update();
    }, 500);
  };

  const initSection = (section) => {
    initSlider(section);

    if (section && section.classList.contains("swiper--multicolumn")) {
      const sectionResizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          initSlider(entry.target);
        });
      });

      sectionResizeObserver.observe(section);
    }
  };

  // document.currentScript is null when a script is executed from a callback or
  // as a module; reading .parentElement off null throws before anything runs.
  if (document.currentScript && document.currentScript.parentElement) {
    initSection(document.currentScript.parentElement);
  }

  document.addEventListener("shopify:section:load", function (section) {
    initSection(section.target);
  });
})();
